import { useAtomValue } from 'jotai';

import { Container } from '@consumer-frontend/shared-ui';

import { NcVerifyIdentityForm } from './NcVerifyIdentityForm';
import { useVerifyIdentitySubmit } from './useVerifyIdentitySubmit';
import { registrationDataAtom } from '../../store';
import { NcPageWithAlertBanner } from '../NcPageWithAlertBanner';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/apply/verify_identity.scss';

export const NcVerifyIdentityReturningCustomerPage: React.FC = () => {
  const { firstName } = useAtomValue(registrationDataAtom);
  const { handleSubmit, isSubmitting } = useVerifyIdentitySubmit(true);

  return (
    <NcPageWithAlertBanner>
      <Container hasBoxShadow className="nc-verify-identity-page">
        <h1 className="h3">Welcome back, {firstName}.</h1>
        <p>We need to verify your identity for security purposes.</p>

        <NcVerifyIdentityForm
          isLoading={isSubmitting}
          onSubmit={handleSubmit}
        />
      </Container>
    </NcPageWithAlertBanner>
  );
};
